import { useCallback, useRef, useState } from 'react';
import { SingularUserMedia, useSingularUserMedia } from 'hooks/useSingularUserMedia';
import { stopStreamTracks } from 'features/user-media/utils';

export const useTemporaryMedia = () => {
  const [loading, setLoading] = useState(false);
  const mediaStream = useRef<MediaStream | null>(null);
  const requestInFlight = useRef(false);
  const requestSingularUserMedia = useSingularUserMedia();

  const requestTemporaryMedia = useCallback(
    async (constraints: SingularUserMedia) => {
      if (requestInFlight.current) {
        return;
      }
      requestInFlight.current = true;

      setLoading(true);

      try {
        const { stream } = await requestSingularUserMedia(constraints, {
          updateActiveDevice: false,
        });

        if (mediaStream.current) {
          stopStreamTracks(mediaStream.current);
        }

        mediaStream.current = stream;
      } finally {
        requestInFlight.current = false;
        setLoading(false);
      }
    },
    [requestSingularUserMedia]
  );

  const cleanupTemporaryMedia = useCallback(() => {
    if (mediaStream.current) {
      stopStreamTracks(mediaStream.current);
      mediaStream.current = null;
    }
  }, []);

  return {
    loading,
    mediaStream: mediaStream.current,
    requestTemporaryMedia,
    cleanupTemporaryMedia,
  };
};
